/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { Grid } from 'antd';

import { Sider } from '@/primitives/Sider';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';
import './MainLayoutSider.css';

export type MainLayoutSiderProps = {
  children: React.ReactNode;
};

const { useBreakpoint } = Grid;

export function MainLayoutSider({ children }: MainLayoutSiderProps) {
  const dark = useMgmtPlaneStateStore((state) => state.darkMode);
  const menuOpen = useMgmtPlaneStateStore((state) => state.menuOpen);
  const setMenuOpen = useMgmtPlaneStateStore((state) => state.setMenuOpen);
  const screens = useBreakpoint();
  const collapsedClass = !menuOpen ? 'collapsed' : '';
  const darkModeClass = dark ? 'mimic-dark-mode' : '';
  const siderClass = `mimic-sider ${collapsedClass} ${darkModeClass}`;

  if (screens.lg) {
    return <Sider className={siderClass}>{children}</Sider>;
  }

  if (!menuOpen) {
    return null;
  }

  return (
    <>
      <Sider className={siderClass}>{children}</Sider>
      <div
        role="button"
        tabIndex={0}
        aria-label="Close sider overlay"
        onClick={() => {
          setMenuOpen(false);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            setMenuOpen(false);
          }
        }}
        data-testid="sider-overlay"
        style={{ backgroundColor: 'rgba(0,0,0,0.3)', width: '100%', height: '100%', position: 'fixed', zIndex: 100 }}
      />
    </>
  );
}
